// src/components/booking/firebase/reservationCleanup.js
import { getRtdb } from "../../../utils/firebase";
import { ref, get, update } from "firebase/database";
import { TTL } from "../../../theme";

export const RESERVATION_TTL_MS = TTL.RESERVATION_MS;

// Reservation data lives in two parallel trees (reservationSlots +
// reservationDetails, see reservationPaths.js) that share the same
// {date}/{court}/{bookingId} key. This only needs to scan the public
// reservationSlots tree to find what's stale (reservedAt lives there,
// no PII involved) - but it removes BOTH halves together via one
// multi-path update() so nothing is ever left orphaned.
export async function cleanupStaleReservationsGlobally() {
  const rtdb = getRtdb();
  const slotsRoot = ref(rtdb, "reservationSlots");
  const snapshot  = await get(slotsRoot);
  if (!snapshot.exists()) return;

  const now = Date.now();
  const staleKeys = []; // [dateStr, courtKey, bookingId]

  snapshot.forEach((dateSnap) => {
    dateSnap.forEach((courtSnap) => {
      courtSnap.forEach((bookingSnap) => {
        const data = bookingSnap.val();
        if (
          data &&
          typeof data.reservedAt === "number" &&
          now - data.reservedAt >= RESERVATION_TTL_MS
        ) {
          staleKeys.push([dateSnap.key, courtSnap.key, bookingSnap.key]);
        }
      });
    });
  });

  if (staleKeys.length === 0) return;

  const updates = {};
  staleKeys.forEach(([dateStr, courtKey, bookingId]) => {
    updates[`reservationSlots/${dateStr}/${courtKey}/${bookingId}`] = null;
    updates[`reservationDetails/${dateStr}/${courtKey}/${bookingId}`] = null;
  });
  await update(ref(rtdb), updates);

  console.debug(`[reservations] Cleaned up ${staleKeys.length} stale reservation(s).`);
}
